import { combineReducers } from "redux";
import configReducer from './ConfigReducer'
import optionsReducer from './OptionsReducer'
import associateReducer from "./AssociateReducer";
import clusterReducer from "./ClusterReducer";
import clusterReducerV2 from "./ClusterReducerV2";
import aisleReducer from "./AisleReducer";
import floorReducer from "./FloorReducer";
import sortZoneReducer from "./SortZoneReducer";
import packageListReducer from "./PackageListReducer";
import stationPairReducer from "./StationPairReducer";
import routeReducer from "./RouteReducer";
import zoneReducer from "./ZoneReducer";
import cartLocationReducer from "./CartLocationReducer";
import overviewReducer from "./OverviewReducer";
import optionsReducerV2 from "./OptionsReducerV2";
import stowBufferReducer from "./StowBufferReducer";
import floorLocationReducer from "./FloorLocationReducer";
import cartReducer from "./CartReducer";
import gridAllocationReducer from "./GridAllocationReducer";

export default combineReducers({
    configReducer: configReducer,
    optionsReducer: optionsReducer,
    associateReducer: associateReducer,
    aisleReducer: aisleReducer,
    clusterReducer: clusterReducer,
    clusterReducerV2: clusterReducerV2,
    floorLocationReducer: floorLocationReducer,
    floorReducer: floorReducer,
    sortZoneReducer: sortZoneReducer,
    packageListReducer: packageListReducer,
    stationPairReducer: stationPairReducer,
    zoneReducer: zoneReducer,
    cartReducer: cartReducer,
    cartLocationReducer: cartLocationReducer,
    routeReducer: routeReducer,
    overviewReducer: overviewReducer,
    optionsReducerV2: optionsReducerV2,
    stowBufferReducer:stowBufferReducer,
    gridAllocationReducer: gridAllocationReducer
});



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js